export const HISTORY_TYPES = {
  STAGE_CHANGE: "stage_change",
  FIELD_UPDATE: "field_update",
  CREATION: "creation",
};

export const LEAD_STAGES = {
  PROSPECTING: 0,
  QUALIFYING: 1,
  PROPOSAL: 2,
  NEGOTIATION: 3,
  WON: 4,
  LOST: 5,
};

export const LEAD_STAGE_LABELS = [
  { id: 0, label: "Prospecting", color: "greyLight", flow: "grey" },
  { id: 1, label: "Qualifying", color: "blueMain", flow: "blue" },
  { id: 2, label: "Proposal", color: "yellowMain", flow: "yellow" },
  { id: 3, label: "Negotiation", color: "mainFocus", flow: "main" },
  { id: 4, label: "Won", color: "greenMain", flow: "green" },
  { id: 5, label: "Lost", color: "redMain", flow: "red" },
];

export const QUOTE_STAGES = {
  DRAFT: 0,
  REVIEW: 1,
  SENT: 2,
  NEGOTIATION: 3,
  WON: 4,
  LOST: 5,
};

export const QUOTE_STAGE_LABELS = [
  { id: 0, label: "Draft", color: "greyLight", flow: "grey" },
  { id: 1, label: "Review", color: "blueMain", flow: "blue" },
  {
    id: 2,
    label: "Sent",
    color: "yellowMain",
    flow: "yellow",
  },
  { id: 3, label: "Negotiation", color: "mainFocus", flow: "main" },
  {
    id: 4,
    label: "Won",
    color: "greenMain",
    flow: "green",
    promptCreate: true,
  },
  { id: 5, label: "Lost", color: "redMain", flow: "red" },
];

export const ACTIVE_LEAD_STAGES = LEAD_STAGE_LABELS.filter(
  (s) => s.id < LEAD_STAGES.WON,
);

export const ACTIVE_QUOTE_STAGES = QUOTE_STAGE_LABELS.filter(
  (s) => s.id < QUOTE_STAGES.WON,
);
